import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { DEVELOPER, SUB_ADMIN, WHITE_LABEL_ADMIN } from "../config/roles";
const PublicRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoggedIn) {
          return (
            <Redirect
              to={{
                pathname:
                  user.role === SUB_ADMIN || user.role === DEVELOPER
                    ? "app/wave-cards"
                    : user.role === WHITE_LABEL_ADMIN
                    ? "app/my-cards"
                    : "/app",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

export default PublicRoute;
